export default "__VITE_ASSET__DhT4UKFA__"